<template>
  <div class="secondContent">
    <Navbar />
    <router-view />
  </div>
</template>

<script>
import Navbar from './NlNavbar'
export default {
  components: { Navbar },
  data() {
    return {
      active: 0
      // showNavbar: false
    }
  },
  created() {
    // this.showNavbar = this.$store.state.platform
  }
}
</script>

<style lang="scss" scoped>
  .secondContent {
    padding-top: 46px;
  }
</style>

